import React from "react";
import Portfolio from "./pages/Portfolio";
import "./styles/global.css";

function App() {
  return (
    <div className="app-root">
      <Portfolio />
    </div>
  );
}

export default App;